import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import getDimensions from './getDimensions';
import getBackgroundPosition from './getBackgroundPosition';
import getCursorPosition from './getCursorPosition';

const bem = new BEMHelper('ZoomedImage');

const ZoomedImage = ({ src, onClick }) => {
    const imageRef = useRef(null);
    const style = {
        backgroundImage: src ? `url(${src})` : 'none',
    };

    useEffect(() => {
        const zoomedImg = imageRef.current;
        const { imageWidth, imageHeight, rx, ry } = getDimensions(zoomedImg);

        // set background size based on ratio
        zoomedImg.style.backgroundSize = `${imageWidth * rx}px ${imageHeight * ry}px`;
    }, []);

    const handleMouseMove = (e) => {
        e.preventDefault();
        const zoomedImg = imageRef.current;

        // set background image position
        const { x, y } = getBackgroundPosition(e, zoomedImg);
        zoomedImg.style.backgroundPosition = `${x}px ${y}px`;
    };

    const handleClick = (e) => {
        if (onClick) {
            const zoomedImg = imageRef.current;
            const { imageWidth, imageHeight } = getDimensions(zoomedImg);
            const cursorPosition = getCursorPosition(e, zoomedImg);
            onClick({ fx: cursorPosition.x / imageWidth, fy: cursorPosition.y / imageHeight });
        }
    };

    return <div ref={imageRef} className={bem()} style={style} onClick={handleClick} onMouseMove={handleMouseMove} />;
};

ZoomedImage.propTypes = {
    src: PropTypes.string,
};

export default ZoomedImage;
